module.exports = __webpack_public_path__ + "static/media/header_help.7b8ace26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_help.jpg
// module id = 317
// module chunks = 1